/**
 * File: contact.ts
 * Path: packages/config/src/voice/contact.ts
 * Description: How customers reach us, in one place for every page.
 * The number is 071-624-9157, written with dashes, never 076 768 6725
 * (Liam, 1 Oct 2026). The contact page, strip and PDFs all read from here.
 */

export const BUSINESS_CONTACT = {
  /** As people read and type it. */
  phone: "071-624-9157",
  /** For tel: links. */
  phoneHref: "tel:+27716249157",
  /** WhatsApp chat with us. */
  whatsappHref: "https://wa.me/27716249157",
  email: "admin@idksolutions.co.za",
  emailHref: "mailto:admin@idksolutions.co.za",
} as const;

/**
 * Opens a WhatsApp chat with us with `message` already typed, so the owner
 * only has to press send. The quote PDF uses it for its button.
 */
export const whatsappMessageHref = (message: string): string =>
  `${BUSINESS_CONTACT.whatsappHref}?text=${encodeURIComponent(message)}`;
